var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { on: { click: _vm.openModal } },
    [
      _c("el-input", {
        attrs: {
          disabled: _vm.disabled,
          placeholder: "请选择" + (_vm.title || "上账产品"),
          value: _vm.name || _vm.value,
        },
      }),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }